var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"completeModal","click-to-close":false,"styles":_vm.styles,"width":480,"height":'auto'},on:{"before-open":_vm.beforeOpen}},[_c('complete-content',{attrs:{"items":_vm.items,"doing-tasks":_vm.doingTasks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }